export enum IndexMethodologyEnum {
  link = '/REZITRADE-Home-Price-Index-Methodology-v23-0808.pdf',
  docTitle = 'REZITRADE - Home Price Index Methodology - v23-0808.pdf',
}
